import { render, staticRenderFns } from "./VirtualLogBuilder.vue?vue&type=template&id=07fc443c&scoped=true&"
import script from "./VirtualLogBuilder.vue?vue&type=script&lang=js&"
export * from "./VirtualLogBuilder.vue?vue&type=script&lang=js&"
import style0 from "./VirtualLogBuilder.vue?vue&type=style&index=0&id=07fc443c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07fc443c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\PhpstormProjects\\warehouse\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('07fc443c')) {
      api.createRecord('07fc443c', component.options)
    } else {
      api.reload('07fc443c', component.options)
    }
    module.hot.accept("./VirtualLogBuilder.vue?vue&type=template&id=07fc443c&scoped=true&", function () {
      api.rerender('07fc443c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "web/typo3conf/ext/ig_warehouse/Resources/Public/Src/JavaScript/components/common/VirtualLogBuilder.vue"
export default component.exports